/** Fuseau horaire d’affichage PRIsME BZ (Québec / heure de l’Est, DST incluse) */
export const APP_DISPLAY_TIME_ZONE = 'America/Toronto' as const;
